export const APL_SAMPLE_REQUEST_DYNAMIC_CONTENT = {
  recipientName: { required: true, visible: true, type: 'input' },
  projectName: { required: false, visible: true, type: 'input' },
  numberSample: { required: false, visible: true, type: 'input' },
  shippingName: { required: true, eye: true, visible: true, type: 'input' },
  shippingCompany: { required: true, eye: true, visible: true, type: 'input' },
  shippingAddress1: { required: true, eye: true, visible: true, type: 'input' },
  shippingAddress2: { eye: true, visible: true, type: 'input' },
  additionalInfo: {
    required: true,
    trash: true,
    visible: true,
    type: 'TextArea',
  },
};

export const SAMPLE_REQUEST_TEMPLATE = `eyJST09UIjp7InR5cGUiOiJkaXYiLCJpc0NhbnZhcyI6dHJ1ZSwicHJvcHMiOnt9LCJkaXNwbGF5TmFtyi9jdXN0b23GIGhpZGRlbiI6ZmFsc2UsIm5vZGVzIjpbIkp3eVZWZV9YclkiLCJkUXZRQTUwbGRLIiwidmQ1MjR2NzVEMiIsInBUYkdmNEtEX04iLCI5VzF3RkQzVXJqIiwiM1NYeHlnamFzWiIsIjV4SEMxUnFCbmsiXSwibGlua2VkTsZre319LMxu6QDceyJyZXNvbHZlZOcAvUVtYWlsRWRpdG9yU2VuZGVySW5mbyJ97AD/5wDG6AEAInNldHRpbmfFDGJvbGTJIml0YWxpY8kPdcRPTGluZckSZm9udFNpemUiOjE0LCJzaG935AEWZGF0ZSIsIm7kAJEsImNvbXBhbnkiLCJhZGRyZXNz5ADdY29sb3IiOiIjMzMzIuQA3O4BguYAuiDlALvuAYpwYXJlbnQiOuYB4/kBmvUBQOsBof8BQOYBQEdyZWXkARn+AT50ZXjkAJBEZWFyIiz/AUz/AUzrAUz/ASHpAJvrAR4idGHEeFsicmVjaXBpZW50xS1d/wE2/wE27ALK/wE25gE2RnJlZVTkART/ATbkATZbIldlIGFyZSBjdXLkAKJseSByZXZpZXdpbmcgeW91ciBwcm9kdWN0cyBmb3IgxBF1cGNvbeYA+nByb2plY3QgYW5kIHdvdWxkIGxpa2UgdG8gcmVxdWVzdCBzYW1wbGXGPWV2YWx1YXRpb24uIFBsZWFzZSBzdWJtaXTkAbbHKG9mIGVhY2jIdiBpZGVudGlmaWVkxFZ0aGUgZm9sbG/lAJ/nAs4uIELESXLFeGluY2x1ZGXJeGluIHJldGFpbCBwYWNrYWfEOHRvIGVuxTFmdWxs6wCXxH5ib3TKfuQA2Mo4cXVhbGl0eS7kAz//Amb/Amb/AmbqAmZDb2505AI49AJl5wF9xSosIm51bWJlclPlAPf/AnL/AnLEPOoFL/8CcuYCclDmATBS5gH1ZWT/AnrmA7DHNXMgyTc6/wO//wFZ/wFZ7QFZx33KfP8E5v8BPu0BPusGYP8BPucGJmhpcHBpbmdU/wYm5wE4xC/pAuB0b/8BNf8BNfYGQHPnAJLnAlzID0PpBknIEkHmA4Mx0hMy/wZl5QZlxzPlBmdybeUDhPUC6/8AkP8AkOgAkP8B1/8B1+wIKv8B1+YB10FkZGnkANJhbP8IAf8IAf8Bwf8C9u0BceoAk/8Bc1vkCCvsAL7/AT3/AT3tCVr/AT3nAxRpZ25pbmdPZmb/AxTmAxRSZWdhcmRzLP8DDP8BS/8BS+4CvOYAoSDkAKL/BDv/ASfqASd9`;

export const SAMPLE_REQUEST_BLANK_TEMPLATE = `eyJST09UIjp7InR5cGUiOiJkaXYiLCJpc0NhbnZhcyI6dHJ1ZSwicHJvcHMiOnt9LCJkaXNwbGF5TmFtyi9jdXN0b23GIGhpZGRlbiI6ZmFsc2UsIm5vZGVzIjpbXSwibGlua2VkTsYRe319fQ==`;

export const APL_SAMPLE_REQUEST_TEMPLATE_LIST = [
  {
    id: 1,
    name: 'Sample Request',
    type: 'sample',
    temp: SAMPLE_REQUEST_TEMPLATE,
  },
  {
    id: 2,
    name: 'Blank',
    type: 'blank',
    temp: SAMPLE_REQUEST_BLANK_TEMPLATE,
    disabled: true,
  },
];

export const EMAIL_CONTENT_SHORT_CODE = '[{rivir_email_content}]';

export const EMAIL_HTML_TEMPLATE = `<!DOCTYPE html>
<html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" lang="en">

<head>
	<title></title>
	<meta charset="UTF-8">
	<meta name="viewport" content="width=device-width, initial-scale=1.0">
	<!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch><o:AllowPNG/></o:OfficeDocumentSettings></xml><![endif]-->
	<style>
    * {
			box-sizing: border-box;
			margin: 0;
			padding: 0;
		}
		p {
			line-height: inherit
		}
	</style>
</head>
<body>
${EMAIL_CONTENT_SHORT_CODE}
</body>

</html>`;


export const SHIPPING_ADDRESS = [
  'shippingName',
  'shippingCompany',
  'shippingAddress1',
  'shippingAddress2',
];